import { KeyboardBackspace } from '@mui/icons-material'
import Button from '../../common/Button'
import ModalWrapper from '../../common/Modal/ModalWrapper'
import { Link } from 'react-router-dom'

const DisclaimerModal = ({ handleClose, subTitle = "This report is for guidance only.", content = "This Report has been prepared by Diligensia for the exclusive use of the named client. It is based on information provided as at the date of issue and is intended solely to assist in identifying risks and opportunities. This report was generated by AI and may be inaccurate.  You are urged to check all report content. Diligentsia accepts no responsibility or liability for any errors, omissions, or delays, nor for any actions taken in reliance on this report. The contents do not constitute legal or financial advice, and professional advice should always be sought. This report may not be relied upon by any third party to whom the report is shown and Diligensia accepts no duty of care or liability to any third party who may obtain access to it.", modalType = 'DisclaimerAIReportModal' }) => {

    return (
        <ModalWrapper
            modalType={modalType}
            customStyle={{ padding: '0px 0rem 2rem', maxWidth: '500px !important' }}
            onCloseHandler={handleClose}
        >
            <div>
                <div
                    onClick={handleClose}
                    style={{
                        backgroundImage: `url(${require('../../../../images/disclaimer.png')})`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        backgroundRepeat: 'no-repeat',
                        height: '90px',
                        marginBottom: '1rem',
                    }}
                    className='df aic jcfs'
                >
                    <h3 className='c15 tal fs1-5rem df aic jcfs'>
                        <KeyboardBackspace className='c2 ml4rem mr1rem' />
                        Disclaimer
                    </h3>
                </div>

                <div className='px4rem'>
                    <h3 className='c15 tal mt3rem'>{subTitle}</h3>
                    <p className='fs11px ttj my1rem' style={{ color: '#505050' }}>{content}</p>
                    <div className='df jcc' >
                        <Button
                            style={{ width: '250px' }}
                            customClassName='mt1rem bg2'
                            text={'Understood'}
                            onClick={handleClose}
                            btnType='dark'
                        />
                    </div>

                    <p className='tac mt1rem' style={{ color: '#505050', fontSize: '13px' }}>
                        See our full
                        <Link clas style={{ color: '#4A67FF', fontSize: '13px', marginLeft: '2px' }} to="/terms-conditions">
                            terms and conditions
                        </Link>, and
                        <Link clas style={{ color: '#4A67FF', fontSize: '13px', marginLeft: '2px' }} to="/policy">
                            policies
                        </Link>.
                    </p>

                </div>

            </div>
        </ModalWrapper>
    )
}

export default DisclaimerModal